<template>
  <b-row>
    <b-col
      sm="12"
      md="5"
      lg="5"
    >
      <b-overlay
        id="overlay-background"
        :show="notesbusy"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-card-header
            class="add-notes-header"
          >
            <b-card-title>{{ $t('DEBTIA_ADD_NOTES') }}</b-card-title>
            <b-card-title class="text-primary">
              <!-- <drag-links
                :parent="7"
                :side="side"
                :custom-change="customChange"
              /> -->
            </b-card-title>
          </b-card-header>
          <b-form>
            <validation-observer
              ref="addnotesform"
              tag="form"
            >
              <b-row>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    label-for="notes"
                    class="mb-1"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Notes"
                      rules="required"
                    >
                      <quill-editor
                        v-model="notes"
                        :options="snowOption"
                        style="min-height: 150px"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_NOTE_VISIBLE_FOR')"
                    label-for="notes-roles"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Roles"
                      rules="required"
                    >
                      <v-select
                        id="notes-roles"
                        v-model="selectedRoles"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        label="label"
                        :options="noteRoles"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-button
                    class="notesSubmitBtn"
                    size="md"
                    variant="primary"
                    type="submit"
                    @click.prevent="notesfieldsfilled"
                  >
                    <span>{{ $t('DEBTIA_SUBMIT') }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </validation-observer>
          </b-form>
          <b-alert
            v-if="showNotesAlert"
            variant="primary"
            class="notes-alert"
            show
          >
            <div class="alert-body">
              <span>{{ $t('DEBTIA_NOTE_ADDED_SUCCESS') }}</span>
            </div>
          </b-alert>
        </b-card>
      </b-overlay>
    </b-col>
    <b-col
      sm="12"
      md="7"
      lg="7"
    >
      <b-overlay
        id="overlay-background"
        :show="historyLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card
          class="custom-curser"
        >
          <b-alert
            v-if="errorMsg"
            variant="warning"
            show
          >
            <div class="alert-body">
              <span>{{ errorMsg }}</span>
            </div>
          </b-alert>
          <b-card-header
            class="case-logs-history-header"
          >
            <b-card-title>{{ $t('DEBTIA_NOTES') }}</b-card-title>
            <b-card-title class="text-primary">
              <!-- <drag-links
          :parent="8"
          :side="side"
          :custom-change="customChange"
        /> -->
            </b-card-title>
          </b-card-header>
          <!-- search here -->
          <b-form-group>
            <b-input-group>
              <b-form-input
                id="search"
                v-model="searchQuery"
                :placeholder="$t('DEBTIA_SEARCH')"
              />
              <b-input-group-append>
                <b-button
                  variant="outline-primary"
                  @click="getNotes()"
                >
                  <feather-icon
                    icon="FilterIcon"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-alert
            v-if="logsFetchingError"
            variant="warning"
            class="notes-alert"
            show
          >
            <div class="alert-body">
              <span>{{ logsFetchingError }}</span>
            </div>
          </b-alert>
          <div
            v-if="caseLogsData.length > 0"
            class="scroll-div"
          >
            <div
              v-for="(data,cldindex) in caseLogsData"
              :key="cldindex"
              class="mt-2"
            >
              <div
                v-if="canshow(data.client_debtor_log_roles)"
              >
                <b-card
                  class="border mb-0"
                >
                  <b-card-text class="card-text content-heading mb-35">
                    <h4>
                      {{ data.title }}
                    </h4>
                    <p>
                      {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}, {{ $t('DEBTIA_CREATED_BY') + " " + data.employee_name }}
                    </p>
                  </b-card-text>
                  <div class="border p-1 padding-content">
                    <div
                      class="business-item"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <label
                          class="note-font"
                          v-html="data.note"
                        />
                        <b-badge variant="light-primary">
                          <b-button
                            :id="'notes-popover-reactive-'+data.id"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="btn-icon"
                          >
                            <feather-icon icon="EyeIcon" />
                          </b-button>
                          <b-button
                            v-if="$ability.can(constants.action.permissionDeleteDebtCaseNote, constants.resource.user) || (!$ability.can(constants.action.permissionDeleteDebtCaseNote, constants.resource.user) && checkOtherDeletionScenario(data))"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="btn-icon ml-1"
                            @click="confirmAndRemove(data.id)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                          <b-popover
                            ref="popover"
                            :target="'notes-popover-reactive-'+data.id"
                            triggers="hover"
                            placement="auto"
                            container="my-container"
                          >
                            <template #title>
                              <div class="d-flex justify-content-between align-items-center">
                                <span>{{ $t('DEBTIA_ALLOWED_ROLES') }}</span>
                              </div>
                            </template>
                            <div>
                              <b-card
                                border-variant="primary"
                                bg-variant="transparent"
                                class="shadow-none"
                              >
                                <b-card-text v-if="data.client_debtor_log_roles.length > 0">
                                  <h6
                                    v-for="(role ,roleindex) in data.client_debtor_log_roles"
                                    :key="roleindex"
                                  >&#8226; {{ getTitle(role.role_id) }} </h6>
                                </b-card-text>

                              </b-card>
                            </div>
                          </b-popover>
                        </b-badge>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
            </div>
          </div>
          <div
            v-else
          >
            There are no records found.
          </div>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BOverlay, BCard,
  BCardHeader,
  BCardTitle,
  BForm,
  BFormGroup,
  BButton,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  // BFormTextarea,
  BCardText,
  BBadge,
  BPopover,
  BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import { EventBus } from '@/event-bus'
import Ripple from 'vue-ripple-directive'
import { quillEditor } from 'vue-quill-editor'
import '@core/scss/vue/libs/quill.scss'
import constants from '@/app-configs/constants'
import { EventBus } from '@/event-bus'
import axios from '@axios'
import i18n from '@/libs/i18n'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BRow,
    BCol,
    BOverlay,
    BCard,
    BCardHeader,
    BCardTitle,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    vSelect,
    quillEditor,
    BAlert,
    BButton,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    // BFormTextarea,
    BCardText,
    BBadge,
    BPopover,
  },
  directives: {
    Ripple,
  },
  props: {
    personType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      caseLogsData: [],
      notes: '',
      noteRoles: [],
      selectedRoles: [],
      searchQuery: '',
      errorMsg: '',
      historyLoader: false,
      notesbusy: false,
      showNotesAlert: false,
      user_role: JSON.parse(localStorage.getItem('userData')).role[0],
      loggedIn_userID: JSON.parse(localStorage.getItem('userData')).data.id,
      constants,
      logsFetchingError: '',
      snowOption: {
        theme: 'snow',
        modules: {
          toolbar: [],
        },
      },
      selectedRoleNames: ['admin', 'company-super-admin', 'employee', 'afdelingsleder', 'legal', 'customer-support', 'finance'],
    }
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0) {
          this.getNotes()
        }
      },
    },
  },
  created() {
    this.getNoteRoles()
    this.getNotes()
    EventBus.$on('refereshNotes', () => {
      this.getNotes()
    })
  },
  methods: {
    checkOtherDeletionScenario(data) {
      let result = false
      if (data.user_id === this.loggedIn_userID && this.dateTimeWithinADay(data.created_at)) {
        result = true
      }
      return result
    },
    dateTimeWithinADay(dateStr) {
      // Create a Date object from the given date string
      const givenDate = new Date(dateStr)

      // Get the current date and time
      const currentDate = new Date()

      // Calculate the difference in milliseconds
      const diffInMs = currentDate - givenDate

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60)

      // Check if the difference is less than 24 hours
      return diffInHours < 24
    },
    confirmAndRemove(id) {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: 'Are you sure to delete this note?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteNote(id)
        }
      })
    },
    async deleteNote(id) {
      this.historyLoader = true
      const personType = this.personType === 1 ? 'clients' : 'debtor'
      const url = `/${personType}/delete-log/${id}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.historyLoader = false
          this.getNotes()
        }
      }).catch(error => {
        console.log('error is ', error)
      })
    },
    canshow(contents) {
      let exists = false
      const loggedInRoleId = this.getLoggedInRoleId()
      const entry = contents.filter(record => record.role_id === loggedInRoleId)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
    getLoggedInRoleId() {
      const entry = this.noteRoles.filter(record => this.UppercaseTransformation(record.name) === this.UppercaseTransformation(this.user_role))
      let id = 0
      if (entry[0]) {
        id = entry[0].value
      }
      return id
    },
    UppercaseTransformation(str) {
      return str.split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    getTitle(role) {
      const entry = this.noteRoles.filter(record => record.value === role)
      let title = 'N/A'
      if (entry[0]) {
        title = entry[0].label
      }
      return title
    },
    getNotes() {
      this.historyLoader = true
      const { id } = this.$route.params
      const personType = this.personType === 1 ? 'clients' : 'debtor'
      axios.get(`/${personType}/get-logs/${id}?search=${this.searchQuery}`).then(response => {
        if (response.status === 200) {
          this.caseLogsData = response.data.data
          this.historyLoader = false
        }
      })
        .catch(error => {
          console.log('error is ', error)
          this.historyLoader = false
          this.errorMsg = error.response.data.message
        })
    },
    getNoteRoles() {
      axios.get('/users/get-user-roles-dropdown').then(response => {
        if (response.status === 200) {
          this.noteRoles = response.data.data
          const roleMap = new Map(response.data.data.map(role => [role.name, role]))

          this.selectedRoles = this.selectedRoleNames
            .map(roleName => roleMap.get(roleName))
            .filter(role => role !== undefined)
        }
      })
        .catch(error => console.log(error))
    },
    async notesfieldsfilled() {
      this.$refs.addnotesform.validate().then(async success => {
        if (success) {
          this.notesbusy = true
          const roles = []
          this.selectedRoles.forEach(x => roles.push(x.value))
          const obj = {
            client_or_debtor_id: this.$route.params.id,
            person_type: this.personType,
            note: this.notes,
            roles,
          }
          const personType = this.personType === 1 ? 'clients' : 'debtor'
          await axios.post(`/${personType}/create-notes`, obj).then(response => {
            if (response.status === 200) {
              this.notesbusy = false
              this.notes = ''
              this.$refs.addnotesform.reset()
              this.getNotes()
            }
          })
        }
      })
    },
  },
}
</script>

<style>
.scroll-div {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 344px;
  padding-right: 10px;
}

.scroll-div::-webkit-scrollbar {
    width: 12px;
}

.scroll-div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.scroll-div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
.ql-container.ql-snow .ql-editor{
  height: 200px !important;
  border-top: 1px solid #d8d6dd;
}

.quill-editor .ql-toolbar.ql-snow {
  display: none;
}
</style>
